import React, { FC, useEffect, useState } from "react";
import "./mostWatchedContent.scss";
import AttemptsIcon from "../../../assets/icons/attempt.svg";
import PlayIcon from "../../../assets/icons/play.svg";
import PdfIcon from "../../../assets/icons/document.svg";
import ThumbUpIcon from "../../../assets/icons/thumb-up.svg";
import ThumbDownIcon from "../../../assets/icons/thumb-down.svg";
import ContentPlaceholder from "../../../assets/placeholder/content-placeholder.svg";

import EyeIcon from "../../../assets/icons/eye.svg";
import { Col, Row, Spin } from "antd";
import faker from "faker";
import { MostWatchedContentModel } from "../../../models/DashboardModel/MostWatchedContentModel/mostWatchedContent.model";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import DashboardFilter from "../DashboardFilter";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";
import { defaultFilter } from "../../../shared/utils/filter";

import { serialize } from "serializr";

interface MostWatchedContentProps { }

const MostWatchedContent: FC<MostWatchedContentProps> = (props:any) => {
  const { user} = props;

  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState<MostWatchedContentModel[]>([]);

  const fetchMostWatchedContents = (params?: any) => {
    setLoading(true)
    const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
    DashboardService.fetchMostWatchedContent(
      payload,
      (contents) => {
        setContents(contents);
        setLoading(false);
      },
      () => {
        setLoading(false)
      },
      () => { }
    );
  };

  useEffect(() => {
    if (user?.roleName === 'admin')
    fetchMostWatchedContents();
  }, []);

  return (
    <div className="most-watched-content">
      <div className="most-watched-content__header-wrapper">
        <div className="most-watched-content__header">
          <img src={EyeIcon} />
          Most watched content
        </div>
        <DashboardFilter
          applyHandler={(values) => fetchMostWatchedContents({ ...defaultFilter, ...values })}
          clearHandler={() => fetchMostWatchedContents()}
        />
      </div>

      <div className="most-watched-content__wrapper">
        {loading ? (
          <Spin tip="Loading..." className="spin__loader" />
        ) : !contents?.length ? (
          <p className="no__data">No data!</p>
        ) : (
          contents?.map((value, index) => {
            return (
              <Row key={"most-watched#" + index} className="most-watched-content__card">
                <Col span={6}>
                  <img
                    className="most-watched-content__thumbnail"
                    src={value?.contentThumbUrl ?? ContentPlaceholder}
                  />
                </Col>
                <Col span={18}>
                  <div className="most-watched-content__card-right">
                    <p className="most-watched-content__card-title">
                      {value?.contentName}
                    </p>
                    <Row>
                      <Col span={6}>
                        <div className="most-watched-content__card-count attempt">
                          <img src={AttemptsIcon} /> {value?.attempts} attempts
                        </div>
                      </Col>
                      {/* {(value?.contentType == "video" ||
                        value?.contentType == "pdf") && (
                        <Col span={6}>
                          <div className="most-watched-content__card-count pdf">
                            <img src={PdfIcon} /> {value?.contentLength}{" "}
                            {value?.contentType == "video" ? "mins" : "pages"}
                          </div>
                        </Col>
                      )} */}
                      <Col span={6}>
                        <div className="most-watched-content__card-count pdf">
                          <img src={PdfIcon} /> {value?.contentLength}
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="most-watched-content__card-count like">
                          <img src={ThumbUpIcon} /> {value?.likes}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-watched-content__card-count dislike">
                          <img src={ThumbDownIcon} /> {value?.dislikes}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MostWatchedContent;
